import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {ReactComponent as Box} from '../../../assets/img/box.svg';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import GavelOutlinedIcon from '@material-ui/icons/GavelOutlined';
import ReactMarkdown from 'react-markdown'
import {Typography} from '@material-ui/core'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {saveApiTabSelection} from '../../stores/ApiTabSelectionParam/ApiTabSelectionParamActions';
import {getStaticResource} from '../../../api/developer';
import connect from 'react-redux/es/connect/connect';
import BILLoader from '../../components/BILLoader/BILLoader';

const useStyles = makeStyles((theme) => ({

    root: {
        marginTop: "30px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        '& > *': {
            margin: theme.spacing(1),
        }
    },
    iconFeature: {
        width: "50px",
        height: "auto",
        color: "white"
    },
    iconDirections: {
        width: "50px",
        height: "auto"
    },
    rootCard: {
        display: 'flex',
        boxShadow: "0 0 16px 0 rgb(0 0 0 / 12%)"
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
        width: 700,
    },
    cover: {
        width: 150,
        height: 300
    }
}));

const BulkOverview = (props) => {

    const classes = useStyles();
    const {overviewConfig, saveApiTabSelection} = props;
    const [content, setContent] = useState("");
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        getStaticResource(overviewConfig)
            .then((res) => setContent(res.data))
            .finally(() => setTimeout(() => {
                setLoading(false)
            }, 700))
    }, []);

    if (isLoading) {

        return (
            <div className="intl-spinner-container">
                <BILLoader/>
            </div>
        )
    }

    return (
        <div>
            <div className="bulk-overview-container">
                <Card className={classes.rootCard}>
                    <div className={classes.details}>
                        <CardContent className={classes.content}>
                            <Typography style={{
                                fontSize: "25px",
                                fontWeight: "300",
                                marginBottom: "-12px",
                                color: "#702fa8",
                                fontFamily: "OpenSans,sans-serif",
                                textRendering: "geometricPrecision"
                            }}>BULK Payment Request</Typography>
                            <hr style={{
                                marginLeft: 0,
                                width: "17%",
                                borderTop: "3px solid",
                                borderColor: "#05C3DE",
                                marginBottom: "10px"
                            }}/>
                            <br/>
                            <Typography variant="subtitle1" color="textSecondary">
                                <ReactMarkdown children={content}/>
                            </Typography>
                            <button className="btn btn-purple" style={{marginTop: "15px", padding: "10px 10px"}}
                                    onClick={() => saveApiTabSelection("Faq")}>
                                More informations
                            </button>
                        </CardContent>
                    </div>
                </Card>
            </div>

            <section className='advantages'>
                <div className="bulk-overview-features-title-container">
                    <div className="bulk-overview-directions-title-item">
                        <h1 style={{color: "white", textAlign: "center"}}>Let’s start</h1>
                        <hr style={{
                            marginLeft: 0,
                            width: "42%",
                            borderTop: "3px solid",
                            borderColor: "#05C3DE",
                            marginTop: "-10px"
                        }}/>
                    </div>
                </div>

                <div className="bulk-overview-features-content-container">

                    <div className="bulk-overview-item">
                        <AssignmentOutlinedIcon className={classes.iconFeature}/>
                        <Typography style={{
                            fontSize: "19px",
                            textAlign: "center",
                            marginTop: "10px",
                            fontWeight: "lighter",
                            fontFamily: "OpenSans,sans-serif",
                            textRendering: "geometricPrecision",
                            width: "300px",
                            color: "white"
                        }}>
                            {"{ OpenAPI - FAQ - Support Team }"} available to help you in your projects developement
                        </Typography>
                    </div>

                    <div className="bulk-overview-item">
                        <Box className={classes.iconFeature}/>
                        <Typography style={{
                            fontSize: "19px",
                            textAlign: "center",
                            marginTop: "10px",
                            fontWeight: "lighter",
                            fontFamily: "OpenSans,sans-serif",
                            textRendering: "geometricPrecision",
                            width: "300px",
                            color: "white"
                        }}>
                            Integrate and test your applications in our sandbox environment
                        </Typography>
                    </div>
                    <div className="bulk-overview-item">
                        <VerifiedUserOutlinedIcon className={classes.iconFeature}/>
                        <Typography style={{
                            fontSize: "19px",
                            fontWeight: "lighter",
                            textAlign: "center",
                            marginTop: "10px",
                            fontFamily: "OpenSans,sans-serif",
                            textRendering: "geometricPrecision",
                            width: "300px",
                            color: "white"
                        }}>
                            Access our APIs using secured market standards in sandbox and production environment
                        </Typography>
                    </div>
                </div>
                <div className="bulk-overview-button-container">
                    <button className="btn btn-transparent" onClick={() => saveApiTabSelection("Documentation")}>
                        Get started
                    </button>
                </div>
            </section>

            <section className='advantages-simple'>

                <div className="bulk-overview-directions-title-container">
                    <div className="bulk-overview-directions-title-item">
                        <h1 style={{color: "grey", textAlign: "center"}}>Directions for use</h1>
                        <hr style={{
                            marginLeft: 0,
                            width: "28%",
                            borderTop: "3px solid",
                            borderColor: "#8f67a5",
                            marginTop: "-10px"
                        }}/>
                    </div>
                </div>

                <div className="bulk-overview-directions-content-container">
                    <div className="bulk-overview-item">
                        <GavelOutlinedIcon className={classes.iconDirections}/>
                        <Typography style={{
                            fontSize: "19px",
                            textAlign: "center",
                            marginTop: "20px",
                            fontWeight: "lighter",
                            fontFamily: "OpenSans,sans-serif",
                            textRendering: "geometricPrecision",
                            width: "700px",
                            color: "grey"
                        }}>
                            Access to the production system is granted only to the Third Party Provider that are
                            authorised under the European PSD2 directive
                        </Typography>
                    </div>
                </div>
            </section>
        </div>

    );
}

//// JS REDUX
const mapStateToProps = (state) => ({
    apiTabSelection: state.apiTabSelectionParam.apiTabSelection,
});

const mapDispatchToProps = {
    saveApiTabSelection,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkOverview);